import React from 'react';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';

import PropTypes from 'prop-types';
import TopMenu from '../component/common/top-nav-new';
import '../asset/styles/setting-menu.css';
import '../asset/styles/setting-compliance-criteria.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Divider from 'material-ui/Divider';


import Button from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';

import {List, ListItem} from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import FileFolder from 'material-ui/svg-icons/file/folder';
import ActionAssignment from 'material-ui/svg-icons/action/assignment';
import {blue500, yellow600,pink500} from 'material-ui/styles/colors';
import EditorInsertChart from 'material-ui/svg-icons/editor/insert-chart';


import TokenService from '../api/tokeninfo';
import eConfig from '../epwp_config.json';

const serverEpwp = eConfig.serverEpwp;

const style = {
    display: 'inline-block',
    margin: '16px 32px 16px 0',
};


class SettingComplianceCriteriaPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company: "",
            username: "",
            LoginUser: {},

            imgProfile:"",
            hasImgProfile:false,

            selectedCompliance:"",
            complianceName: "",
            complianceScore: "",
            base64String_compliance:"",
            base64String_profile:"",
            filename_compliance:"",
            filename_profile:"",

            open: false,
            openPic:false,
            selected: [1],

            currUser:{},
            Compliances: [],
            Documents: [],
        }

        this.fetchComplianceCriteria = this.fetchComplianceCriteria.bind(this);
        this.fetchComplianceDocuments= this.fetchComplianceDocuments.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.renderDialog = this.renderDialog.bind(this);
        this.renderUploadProPicture = this.renderUploadProPicture.bind(this);

        this.handleInput = this.handleInput.bind(this);
        this.submitComplianceDocument = this.submitComplianceDocument.bind(this);
        this.submitProfilePicture  =this.submitProfilePicture.bind(this);
        this.handleInputMandatory = this.handleInputMandatory.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.renderComplianceCriteria = this.renderComplianceCriteria.bind(this);
        this.handleRowSelection = this.handleRowSelection.bind(this);
        this.userInfo = this.userInfo.bind(this);
        this.EmployeeSection = this.EmployeeSection.bind(this);
        this.renderDocuments = this.renderDocuments.bind(this);
        this.getImgProfile = this.getImgProfile.bind(this);
        this.openChangePicture = this.openChangePicture.bind(this);
        this.closeChangePicture = this.closeChangePicture.bind(this);

        this.handleInputUpload = this.handleInputUpload.bind(this);

        this.iframeDocument=this.iframeDocument.bind(this);
        this.closeIframbutton=this.closeIframbutton.bind(this);


    }

    componentWillMount() {
        var u = TokenService.GetTokenObject();
        let tmp = this.state;
        tmp.company = u.Company;
        tmp.username = u.Email;
        tmp.LoginUser = u;
        this.setState(tmp);
        /**
         * Load default from api
         */
        this.fetchComplianceCriteria();
        this.fetchComplianceDocuments();
        this.userInfo();

    }

    isSelected(index) {
        console.log("isSelected > ", index);
        return this.state.selected.indexOf(parseInt(index)) !== -1;
    };

    handleInput(e, key,value) {
        const val = value;
        let tmp = this.state;
        tmp[key] = val;
        this.setState(tmp);
        console.log("handleInput change > ", key, val,value);
    }

    handleRowSelection = (row) => {
        console.log("handleRowSelection > ", row);
        let text = window.confirm("Are you sure that you want to delete this compliance: "+row.Name);
        if(!text){
            return
        }

        let endpoint = "/api/compliance/criteria/delete";
        let url = serverEpwp + endpoint;
        let hub = row;

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((responseData) => {
                alert("Compliance deleted");
                this.fetchComplianceCriteria();
                console.log("+++++>fetchComplianceCriteria List response ", responseData);
            });

    };

    handleInputMandatory(e, index, value) {
        let key = "complianceMandatory";
        let tmp = this.state;
        tmp[key] = value;
        this.setState(tmp);
    }

    handleClickOpen() {
        this.setState({open: true});
    }
    openChangePicture(){
        this.setState({openPic: true});
        //alert("Not implement yet, try again later");
    }
    closeChangePicture(){
        this.setState({openPic: false});
    }

    handleClose() {
        this.setState({open: false});
    }

    fetchComplianceDocuments(){
        this.userInfo();
        let endpoint = "/api/compliance/document/list-employee";
        let url = serverEpwp + endpoint;
        let hub = {};
        hub.company = this.state.currUser.Company;
        hub.EmployeeNumber = this.state.currUser.EmployeeCode;
        //hub.ContractName = this.state.currUser.ContractName;

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((responseData) => {

            let data  = [];
            for(let i in responseData){
                let row = responseData[i];
                if(row.ComplianceName ==="Profile-Picture"){
                    console.log("profile url 2 > ",row);
                    let tmp = this.state;
                    tmp.hasImgProfile = true;
                    tmp.imgProfile = "http://biadebt.easipath.com:33332/download/rev/file/"+row.DropboxId+"/"+row.FileName;
                    this.setState(tmp);
                }else{
                    data.push(row);
                }
            }
                var tmp = this.state;
                tmp["Documents"] = data;
                this.setState(tmp);
                console.log("+++++>fetchComplianceDocuments List response ", responseData,hub);
            });
    }

    fetchComplianceCriteria() {

        let storeContract = window.localStorage.getItem("SELECTED-CONTACT");
        let company = this.state.company;
        let endpoint = "/api/compliance/criteria/list";
        let url = serverEpwp + endpoint;
        let hub = {};
        hub.company = company;
        hub.contractName = storeContract;


        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((responseData) => {
                let data = [];
                let index = 0;
                for (let i in responseData) {
                    let row = responseData[i];
                    index++;
                    row.num = index;
                    data.push(row);
                }
                var tmp = this.state;
                tmp["Compliances"] = data;
                this.setState(tmp);
                console.log("+++++>fetchComplianceCriteria List response ", responseData);
            });
    }

    submitProfilePicture(){
        let company = this.state.company;
        let endpoint = "/api/services/compliance-document/new";
        let url = serverEpwp + endpoint;
        let hub = {};
        hub.Base64String = this.state.base64String_profile;
        hub.FileName= this.state.filename_profile;
        hub.ContractName =this.state.currUser.Contract;
        hub.DocType = "Profile-Picture";
        hub.Company = company;
        hub.EmployeeNumber =this.state.currUser.EmployeeCode;
        let arr = this.state.selectedCompliance.split("--");
        hub.ComplianceName = "Profile-Picture";
        hub.ScoreWeight = 0;
        hub.Username = this.state.username;

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((responseData) => {
                alert("Compliance Added");
                this.handleClose();
                this.fetchComplianceCriteria();
                this.fetchComplianceDocuments();
                console.log("+++++>submitComplianceDocument List response ", responseData);
            });

    }






    submitComplianceDocument() {

        let company = this.state.company;
        let endpoint = "/api/services/compliance-document/new";
        let url = serverEpwp + endpoint;
        let hub = {};
        hub.Base64String = this.state.base64String_compliance;
        hub.FileName= this.state.filename_compliance;
        hub.ContractName =this.state.currUser.Contract;
        hub.DocType = "Compliance-Document";
        hub.Company = company;
        hub.EmployeeNumber =this.state.currUser.EmployeeCode;
        let arr = this.state.selectedCompliance.split("--");
        hub.ComplianceName = arr[0];
        hub.ScoreWeight = arr[1];
        hub.Username = this.state.username;

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((responseData) => {
                alert("Compliance Added");
                this.handleClose();
                this.fetchComplianceCriteria();
                this.fetchComplianceDocuments();
                console.log("+++++>submitComplianceDocument List response ", responseData);
            });


    }

    handleInputUpload(e,key){

        let inputUpload = document.getElementById("myfile_"+key);
        let myfile = inputUpload.files[0];
        if (!myfile) {
            console.log("No file selected.");
            return;
        }
        let _this = this;
        let reader = new FileReader();
        reader.readAsDataURL(myfile);
        reader.onload = function () {
            let tmp = _this.state;
            tmp["base64String_"+key] = reader.result;
            tmp["filename_"+key] = myfile.name;
            _this.setState(tmp);
            console.log("handleInputUpload ------>> ",key," > ",myfile.name)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }



    renderUploadProPicture(){
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.closeChangePicture}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                keyboardFocused={true}
                onClick={this.submitProfilePicture}
            />,
        ];

        return (
            <div>
                <Dialog
                    title="Add New Profile Picture"
                    actions={actions}
                    modal={false}
                    open={this.state.openPic}
                    onRequestClose={this.closeChangePicture}
                    autoScrollBodyContent={true}
                >

                    <br/>


                    <input
                        type="file"
                        className="form-control"
                        id={"myfile_profile"}
                        onChange={(e) => {
                            this.handleInputUpload(e, "profile")
                        }}
                    /><br/>


                </Dialog>
            </div>
        )
    }

    renderDialog() {

        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                keyboardFocused={true}
                onClick={this.submitComplianceDocument}
            />,
        ];


        return (
            <div>
                <Dialog
                    title="Add New Compliance Criteria"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}
                >

                    <br/>

                    <div className="col-lg-12">
                    <SelectField
                        fullWidth={true}
                        floatingLabelText="Compliance Criteria"
                        value={this.state.selectedCompliance}
                        onChange={(e,ee,val) => {
                            this.handleInput(e, "selectedCompliance",val)
                        }}
                    >

                        {this.state.Compliances.map((row)=>{
                            return(
                            <MenuItem value={row.Name+"--"+row.ScoreWeight} primaryText={row.Name}/>
                            )
                        })}
                        {/*<MenuItem value={true} primaryText="Yes"/>
                        <MenuItem value={false} primaryText="No"/>*/}
                    </SelectField>
                    </div>
                    <br/>

                    <input
                        type="file"
                        className="form-control"
                        id={"myfile_compliance"}
                        onChange={(e) => {
                            this.handleInputUpload(e, "compliance")
                        }}
                    /><br/>


                </Dialog>
            </div>
        )
    }

    renderComplianceCriteria() {

        const myMandatory = function (inme) {
            if (inme) {
                return "Yes"
            }
            return "no";
        }
        let index = 0;
        return (
            <div>
                <Table className="mycompliance">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn width={50}>ID</TableHeaderColumn>
                            <TableHeaderColumn width={750}>Name</TableHeaderColumn>
                            {/*<TableHeaderColumn>Description</TableHeaderColumn>*/}
                            <TableHeaderColumn width={50}>Score</TableHeaderColumn>
                            <TableHeaderColumn width={50}>Mandatory</TableHeaderColumn>
                            <TableHeaderColumn>#</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.state.Compliances.map((row) => {
                            index++;
                            return (
                                <TableRow>
                                    <TableRowColumn width={50}>{index}</TableRowColumn>
                                    <TableRowColumn width={750}>{row.Name}</TableRowColumn>
                                    {/*<TableRowColumn>{row.Detail}</TableRowColumn>*/}
                                    <TableRowColumn width={50}>{row.ScoreWeight}</TableRowColumn>
                                    <TableRowColumn width={50}>{myMandatory(row.Mandatory)}</TableRowColumn>
                                    <TableRowColumn>
                                        <FlatButton
                                            label="Delete"
                                            secondary={true}
                                            keyboardFocused={true}
                                            onClick={()=>{this.handleRowSelection(row)}}
                                        /><br/>
                                    </TableRowColumn>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                <br/>



            </div>
        );
    }

    userInfo(){
        const strInfo =  window.localStorage.getItem("PROFILE-EMPLOYEE");
        const user =JSON.parse(strInfo);
        let tmp = this.state;
        tmp.currUser = user;
        this.setState(tmp);

        console.log("User info > ",user);
    }
    getImgProfile(){

        if(!this.state.hasImgProfile ){
            return(
                <img
                    title="Profile"
                    src={defaultUserProfileImg()}
                    alt="PIC Profile"
                    width={278}
                    height={175}
                />
            )
        }

        console.log("profile url > ",this.state.imgProfile);

        return(
            <img
                title="Profile"
                src={this.state.imgProfile}
                alt="PIC Profile"
                width={278}

            />
        )

    }

    EmployeeSection() {
       return(
           <div>
            <Paper style={style}>
                {this.getImgProfile()}

                <Menu>
                    <MenuItem primaryText={"Code: "+this.state.currUser.EmployeeCode}/>
                    <MenuItem primaryText={"Name: "+this.state.currUser.Name+" "}/>
                    <MenuItem primaryText={"Snme: "+this.state.currUser.Surname+" "}/>
                    <MenuItem primaryText={"Site: "+this.state.currUser.Site}/>
                    <MenuItem primaryText={"Role: "+this.state.currUser.Designation}/>
                </Menu>
                <p style={{textAlign:"center"}}>
                    <FlatButton
                        label="Click here to Change Picture"
                        secondary={true}
                        keyboardFocused={true}
                        onClick={this.openChangePicture}
                    />
                </p>
            </Paper>
        </div>
       )
    }



    iframeDocument(urlToDownload,filename) {
        //todo IFRAME view
        var iframe = window.document.createElement('iframe');
        iframe.setAttribute('style', 'position:absolute;right:0; top:170px; bottom:0; height:100%; width:500px');
        iframe.setAttribute("id", "myIframe");
        window.document.body.appendChild(iframe);
        iframe.src = urlToDownload;
        window.document.getElementById('closeIframbutton').style.visibility = 'visible';
        window.document.getElementById('backBtn').style.visibility = 'hidden';
        console.log(" row.FileBase64String > ", urlToDownload)
    }

    closeIframbutton() {
        var iframe = window.document.getElementById('myIframe');
        window.document.body.removeChild(iframe);
        window.document.getElementById('closeIframbutton').style.visibility = 'hidden';
        window.document.getElementById('backBtn').style.visibility = 'visible';
    }

    renderDocuments(){

        console.log("renderDocuments---> ",this.state.Documents);

        return(

            <div className="myBoxListItemDoc">
                <List>
                    <Subheader inset={true}>Files Uploaded</Subheader>
                    <Divider inset={true} />

                    {this.state.Documents.map((row)=>{
                        let myDownloadUrl = "http://biadebt.easipath.com:33332/download/rev/file/"+row.DropboxId+"/"+row.FileName;
                        return(
                            <ListItem
                                leftAvatar={<Avatar icon={<ActionAssignment />} backgroundColor={pink500} />}
                                rightIcon={<ActionInfo />}
                                primaryText={<div>
                                    {row.ComplianceName} &nbsp;&nbsp;|&nbsp;
                                    <a className="clickMe" style={{color:"blue"}} onClick={()=>{downloads(myDownloadUrl,row.FileName)}}>Download</a>
                                    &nbsp;&nbsp;|&nbsp;
                                    <a className="clickMe" style={{color:"blue"}} onClick={()=>{this.iframeDocument(myDownloadUrl,row.FileName)}}>View</a>
                                </div>}
                                secondaryText={row.OrgDateTime +" | Size: "+row.Size}
                            />
                        )
                    })}

                </List>
            </div>

        )
    }

    render() {
        return (
            <div className="">
                <TopMenu page="Compliance Criteria" menu={this.props.location.pathname}/>

                <div className="pageContentWhite">

                    <div className="container borderShadon">
                        <MuiThemeProvider>
                        <div className="container">
                            <br/>
                                <div className="row">
                                    <div className="col col-lg-12">
                                        <h4>
                                            <label style={{color: "#03A9F4"}}>Compliance Documents</label>
                                            <button onClick={this.handleClickOpen}
                                                    className="btn btn-primary pull-right addButton">Upload New Doc
                                            </button>
                                        </h4>
                                        {this.renderDialog()}
                                        {this.renderUploadProPicture()}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col col-lg-3">
                                        {this.EmployeeSection()}
                                    </div>

                                    <div className="col col-lg-9">
                                        {this.renderDocuments()}
                                        <br/>
                                        <br/>
                                        <button id="backBtn" className="btn btn-danger" style={{marginLeft:"80px"}} onClick={()=>{window.location.href="#/employee"}}>
                                            <i className="glyphicon glyphicon-backward"></i> Back to employee database
                                        </button>

                                        <br/>
                                        <br/>

                                        <button
                                            style={{marginLeft:"80px"}}
                                            id={"closeIframbutton"}
                                            onClick={() => this.closeIframbutton()}
                                            className={"btn btn-warning hidenMe"}
                                        >
                                            <i className="glyphicon glyphicon-remove"></i>
                                            Close this view Frame
                                        </button>

                                    </div>

                                </div>
                        </div>
                        </MuiThemeProvider>
                    </div>
                </div>


            </div>

        )
    }
}

SettingComplianceCriteriaPage.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default SettingComplianceCriteriaPage;

function viewDoc(urlToDownload,filename){

}

function downloads(urlToDownload,filename){
    var boo = window.confirm("Are you sure that you want to download this link : "+urlToDownload);
    if(!boo){
        return
    }

    var url = urlToDownload;
    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
        var a = document.createElement('a'); // create html element anchor
        a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
        a.download = filename; // Set the file name.
        a.style.display = 'none'; // set anchor as hidden
        document.body.appendChild(a);
        a.click();
        a.remove()
    };
    xhr.open('GET', url);
    xhr.send();
}


function defaultUserProfileImg(){
    return `data:image/jpeg;base64,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`
}